import { useAppDispatch, useAppSelector } from "hooks";
import React, { useEffect } from "react";
import { simFlowFetchData, simFlowFetchSimRequestData } from "../../../../redux/simFlow/simFlowSlice";
import CommonLoader from "components/CommonLoader";
import dayjs from "dayjs";

type PublishUpdatetoRTOProps = {
  id: any;
};

// eslint-disable-next-line sonarjs/cognitive-complexity
function PublishUpdatetoRTO({ id }: PublishUpdatetoRTOProps) {
  // eslint-disable-next-line sonarjs/no-duplicate-string
  const simSelectorData = useAppSelector((state) => state.simFlow.simFlow.data[6].data);
  const [simSelector, setSimSelector] = React.useState<any>(simSelectorData);

  const simError = useAppSelector((state) => state.errorStep.simError);
  const isError = simError ? simError.step >= 13 : false;
  const isAlreadyFetched =
    simSelectorData instanceof Array
      ? false
      : "status" in simSelectorData
        ? true
        : simSelectorData.flow_dtl_id === Number(id);

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!isError && !isAlreadyFetched) {
      dispatch(simFlowFetchData());
      dispatch(simFlowFetchSimRequestData({ id, stepId: 13 }));
    } else {
      setSimSelector(simSelectorData);
    }
  }, [dispatch, id, isAlreadyFetched, isError, simSelectorData]);
  const simSelectorLoading = useAppSelector((state) => state.simFlow.simFlow.loading);
  // const [requestData] = React.useState<any>(simSelector.request_json);
  // const [responseData] = React.useState<any>(simSelector.response_json);
  // console.log("requestData", simSelector?.request_json?.metadata?.sourceSystem);
  const vehicleIdentifierData: Array<any> = [
    {
      id: 1,
      name: "UNR",
      value: simSelector?.request_json?.payload?.[0]?.key?.urn ?? "",
    },
    {
      id: 2,
      name: "Model Year",
      value: simSelector?.request_json?.payload?.[0]?.key?.modelYear ?? "",
    },
  ];

  const rtoEventData: Array<any> = [
    {
      id: 1,
      name: "RTO ID",
      value: simSelector?.request_json?.payload?.[0]?.rtoId ?? "",
    },
    {
      id: 2,
      name: "Requested Model Code",
      value: simSelector?.request_json?.payload?.[0]?.requestedModelCode ?? "",
    },
    {
      id: 3,
      name: "Requested Exterior Color Code",
      value: simSelector.request_json?.payload?.[0]?.requestedExteriorColorCode ?? "",
    },
    {
      id: 4,
      name: "Requested Interior Color Code",
      value: simSelector.request_json?.payload?.[0]?.requestedInteriorColorCode ?? "",
    },
    {
      id: 5,
      name: "Requested Factory Accessories",
      value: simSelector.request_json?.payload?.[0]?.requestedFactoryAccessory ?? "",
    },
    {
      id: 6,
      name: "Requested Inline Accessories",
      value: simSelector.request_json?.payload?.[0]?.requestedInlineAccessory ?? "",
    },
    {
      id: 7,
      name: "RTO Status",
      value: simSelector.request_json?.payload?.[0]?.rtoStatus ?? "",
    },
  ];

  const Spec200V1: string = simSelector.request_json?.payload?.[0]?.spec200WithoutOverlays ?? "";
  const Spec200V2: string = simSelector.request_json?.payload?.[0]?.spec200WithOverlays ?? "";
  const Accepted200Spec: string = simSelector.request_json?.payload?.[0]?.accepted200Spec ?? "";

  // const specData: Array<any> = [
  //   {
  //     id: 1,
  //     name: "Spec 200 V1",
  //     data: Spec200V1,
  //   },
  //   {
  //     id: 2,
  //     name: "Spec 200 V2",
  //     data: Spec200V2,
  //   },
  //   {
  //     id: 3,
  //     name: "Accepted 200 Spec",
  //     data: Accepted200Spec,
  //   },
  // ];
  const metaData: Array<any> = [
    {
      id: 1,
      name: "Event Domain",
      value: simSelector.request_json?.metadata?.eventDomain ?? "",
    },
    {
      id: 2,
      name: "Source System",
      value: simSelector.request_json?.metadata?.sourceSystem ?? "",
    },
    {
      id: 3,
      name: "User ID",
      value: simSelector.request_json?.metadata?.userId ?? "",
    },
    {
      id: 4,
      name: "GUID",
      value: simSelector.request_json?.metadata?.GUID ?? "",
    },
    {
      id: 5,
      name: "Event Type",
      value: simSelector.request_json?.metadata?.eventType ?? "",
    },
    {
      id: 6,
      name: "Issue Time",
      value: dayjs(simSelector.request_json?.metadata?.issueTime).format("YYYY-MM-DD HH:mm:ss") ?? "",
    },
  ];

  const renderData: Array<any> = [
    {
      id: 1,
      title: "Vehicle Identifier",
      data: vehicleIdentifierData,
    },
    {
      id: 2,
      title: "RTO Event",
      data: rtoEventData,
    },
    {
      id: 3,
      title: "MetaData",
      data: metaData,
    },
  ];
  useEffect(() => {
    // console.log("requestData", nsoSelector);
  }, [simSelector]);
  if (simSelectorLoading) {
    return <CommonLoader active={simSelectorLoading} />;
  }
  return (
    <>
      <div className="border border-gray-300 rounded-lg shadow-lg gap-4">
        {renderData.map((item) => {
          return (
            <div className="w-full bg-gray-100 rounded-lg py-2 m-2" key={item.id}>
              <div className="flex w-full justify-start items-center content-center">
                <span className="font-bold mx-4 text-xl">{item.title}</span>
              </div>
              <div className="border border-gray-300 rounded-lg my-2 mx-0"></div>
              <div className="grid grid-cols-3 m-4 gap-4">
                {item.data.map((items: any) => (
                  <div className="" key={items.id}>
                    <div className="bg-yellow grid grid-cols-2 m-2 gap-4">
                      <div className="text-base">{items.name}</div>
                      {item.name === "Factory" || item.name === "PPO" ? (
                        <div className="text-base"></div>
                      ) : (
                        <div className="text-base whitespace-pre-wrap break-words ">{items.value}</div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
        <div className="flex w-full justify-start items-center content-center">
          <span className="font-bold mx-4 text-xl">Specifications</span>
        </div>
        <div className="border border-gray-300 rounded-lg my-2 mx-0"></div>
        <div className="w-full bg-gray-100 rounded-lg py-2 m-2">
          <div className="flex w-full justify-start items-center content-center">
            <span className="font-bold mx-4 text-xl">Specifications</span>
          </div>
          <div className="border border-gray-300 rounded-lg my-2 mx-0"></div>
          <div className="grid grid-cols-12 m-4 gap-4">
            <div className="text-base w-fit col-start-1 col-end-3 flex align-items items-center flex flex-col justify-center gap-2 mt-2">
              <div className="">Spec 200 V1</div>
              <div className="">Spec 200 V2</div>
              <div className="">Accepted 200 Spec</div>
            </div>
            <div className="overflow-x-auto py-2 col-start-3 col-end-12">
              <table className="min-w-full">
                <tr>
                  {Spec200V1?.split("").map((item: string, index: number) => {
                    return (
                      <td key={index} className="p-2 w-2  text-center">
                        {index + 1}
                      </td>
                    );
                  })}
                </tr>
                <tr>
                  {Spec200V1?.split("").map((item: string, index: number) => {
                    return (
                      <td key={index} className="p-2 w-12  text-center">
                        {item}
                      </td>
                    );
                  })}
                </tr>
                <tr>
                  {Spec200V2?.split("").map((item: string, index: number) => {
                    return (
                      <td key={index} className="p-2 w-12  text-center">
                        {item}
                      </td>
                    );
                  })}
                </tr>
                <tr>
                  {Accepted200Spec?.split("").map((item: string, index: number) => {
                    return (
                      <td key={index} className="p-2 w-12  text-center">
                        {item}
                      </td>
                    );
                  })}
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PublishUpdatetoRTO;
